import { Container } from "@sainsburys-tech/luna-grid";
import { BreadcrumbsItem, BreadcrumbsWrapper } from "@sainsburys-tech/luna-breadcrumbs";
import { useEffect, useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import SearchForm from "../../SearchForm/SearchForm";
import { initialValueOfFamilyGroupModel } from "../../../Models/FamilyGroupModel";
import Summary from "../Summary/summary";
import Management from "../Management/management";
import { useSelector } from "react-redux";
import DataTable from "./DataTable";
import { ValuesType } from "../../../Types/InitialStateType";

const FamilyGroupAdministrationSearch = () => {
  const [filters, setFilters] = useState("");
  const [breadCrumb, setBreadCrumb] = useState(false);
  const [disableSearchForm, setDisableSearchForm] = useState(false);
  const [createButton, setCreateButton] = useState(false);
  const [dataTablePayload, setDataTablePayload] = useState();

  const history = useHistory();
  const location = useLocation();
  const { data, isDirectQuery, parentName, selectedMenu } = useSelector(
    (state: any) => state.filterReducer.data
  );
  const payload = useSelector((state: any) => state.dataTableReducer);
  const nonDirectQueryRespnse = useSelector(
    (state: any) => state.menuHeaderReducer?.data
  );
  // consolelog('payload', payload)

  useEffect(() => {
    setDataTablePayload(payload);
  }, []);

  let searchPayload: ValuesType[] = [
    {
      name: "Search",
      label: "Search",
      value: "",
      searchMethod: "contains",
      searchOperator: "or",
    },
  ];

  const initialState = {
    values: searchPayload,
    submitted: false,
    dirty: false,
  };

  const toggleSearch = (isDisabled: boolean) => {
    setDisableSearchForm(isDisabled);
  };

  useEffect(() => {
    setCreateButton(selectedMenu === "Management");
  }, [selectedMenu]);

  useEffect(() => {
    setFilters("");
  }, [selectedMenu]);

  return (
    <>
      <Container className="containerPanelFullHeight" soft data-test="add">
        {breadCrumb && (
          <BreadcrumbsWrapper>
            <BreadcrumbsItem>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  history.push("/familyGroupAdmin/Summary");
                }}
              >
                Family Group Admin
              </a>
            </BreadcrumbsItem>
            <BreadcrumbsItem active>Family Group Admin</BreadcrumbsItem>
          </BreadcrumbsWrapper>
        )}

        <h4 style={{ display: "inline" }}>Family Group Admin</h4>
        <span className="orangeSainsburysAction">
          {" "}
          | {" "}
          {selectedMenu === "Management"
            ? "Management"
            : 
              nonDirectQueryRespnse?.selectedMenu !== null
            ? "Summary"
            : selectedMenu}
        </span>

        <SearchForm
          initialState={initialState}
          isDisabled={disableSearchForm}
          //setFilters={setFilters}
          model={initialValueOfFamilyGroupModel}
          hasCreateButton={createButton}
          key={selectedMenu}
        />

        <Switch>
          <Route path={`/familyGroupAdmin/summary`}>
            <Summary toggleSearchPanel={toggleSearch} />
          </Route>
          <Route path={`/familyGroupAdmin/management`}>
            <Management toggleSearchPanel={toggleSearch} />
          </Route>
        </Switch>

        {dataTablePayload && (
          <Container
            className="gridContainer containerPanelFullWidthWithWhiteBKG"
            soft
          >
            <DataTable
              service={payload.data.service}
              columnDefinition={payload.data.columnDefinition}
              toggleSearchPanel={payload.data.toggleSearchPanel}
              isColumnMerge={payload.data.isColumnMerge}
              isPaginationRequired={payload.data.isPaginationRequired}
            />
          </Container>
        )}
      </Container>
    </>
  );
};
export default FamilyGroupAdministrationSearch;
